<template>
  <div class="newbie-gift">
    <!-- Header -->
    <nav class="ng-header">
      <button class="ng-header__back" @click="$router.go(-1)">
        <van-icon name="arrow-left" size="20" color="#ffffff" />
      </button>
      <h1 class="ng-header__title">{{ $lang.ng_title }}</h1>
      <div class="ng-header__spacer"></div>
    </nav>

    <main class="ng-main">
      <!-- Hero Section -->
      <section class="ng-hero">
        <div class="ng-hero__img-wrap">
          <img
            class="ng-hero__img"
            src="../../../assets/img/activity/activity_banner/newbee/1.png"
          />
          <!-- Best Value Badge -->
          <div class="ng-hero__badge">{{ $lang.ng_best_value || 'BEST VALUE' }}</div>
        </div>

        <!-- Countdown Timer -->
        <div class="ng-timer">
          <span class="ng-timer__label">{{ $lang.ng_limited_time }}</span>
          <div class="ng-timer__tube" :class="{ 'ng-timer__tube--green': purchased }">
            <div class="ng-timer__pulse"></div>
            <span class="ng-timer__digits" :class="{ 'ng-timer__digits--green': purchased }">
              {{ countdownDisplay }}
            </span>
          </div>
        </div>
      </section>

      <!-- Reward Track -->
      <section class="ng-rewards">
        <div
          v-for="(day, idx) in days"
          :key="idx"
          class="ng-reward-card"
          :class="{
            'ng-reward-card--active': day.status === 'active',
            'ng-reward-card--locked': day.status === 'locked',
            'ng-reward-card--claimed': day.status === 'claimed'
          }"
        >
          <!-- Icon -->
          <div class="ng-reward-card__icon" :class="{ 'ng-reward-card__icon--active': day.status === 'active' || day.status === 'claimed' }">
            <img :src="day.icon" class="ng-reward-card__icon-img" />
          </div>

          <!-- Info -->
          <div class="ng-reward-card__info">
            <div class="ng-reward-card__head">
              <span v-if="day.status === 'active'" class="ng-badge ng-badge--active">{{ $lang.ng_active || 'Active' }}</span>
              <span v-if="day.status === 'claimed'" class="ng-badge ng-badge--claimed">{{ $lang.ng_claimed }}</span>
              <h3 class="ng-reward-card__title">{{ day.title }}</h3>
            </div>
            <p class="ng-reward-card__desc" v-safe-html.rich="day.desc"></p>
          </div>

          <!-- Button -->
          <button
            v-if="day.status === 'active'"
            class="ng-reward-card__btn ng-reward-card__btn--active"
            @click="claimReward(idx + 1)"
          >
            {{ $lang.ng_claim }}
          </button>
          <button
            v-else-if="day.status === 'claimed'"
            class="ng-reward-card__btn ng-reward-card__btn--disabled"
            disabled
          >
            {{ $lang.ng_claimed }}
          </button>
          <button
            v-else
            class="ng-reward-card__btn ng-reward-card__btn--locked"
            disabled
          >
            <van-icon name="lock" size="12" />
            <span v-if="day.countdown">{{ day.countdown }}</span>
            <span v-else>{{ $lang.ng_claim }}</span>
          </button>
        </div>
      </section>

      <div class="ng-spacer"></div>
    </main>

    <!-- Footer (only when not purchased) -->
    <div v-if="!purchased" class="ng-footer">
      <div class="ng-footer__row">
        <div class="ng-footer__price">
          <span class="ng-footer__price-label">{{ $lang.ng_limited_price }}</span>
          <div class="ng-footer__price-row">
            <span class="ng-footer__price-current">{{ getCurrency }}{{ $formatNumberWithCommas(price) }}</span>
            <span v-if="originalPrice && Number(originalPrice) > Number(price)" class="ng-footer__price-original">{{ getCurrency }}{{ $formatNumberWithCommas(originalPrice) }}</span>
          </div>
        </div>
        <div class="ng-footer__value">
          <span class="ng-footer__value-pct">+200%</span>
          <p class="ng-footer__value-label">{{ $lang.ng_total_value || 'TOTAL VALUE' }}</p>
        </div>
      </div>
      <button class="ng-footer__buy" :disabled="paying" @click="buyNow">
        {{ paying ? ($lang.common_loading || 'Loading...') : $lang.ng_buy_now }}
      </button>
      <p class="ng-footer__disclaimer">{{ $lang.ng_disclaimer }}</p>
    </div>

    <!-- Treasure Chest Popup -->
    <van-popup
      v-model="showChestPopup"
      round
      :close-on-click-overlay="true"
      class="ng-popup-wrapper"
    >
      <div class="ng-popup">
        <!-- Header -->
        <div class="ng-popup__header">
          <h2 class="ng-popup__title">{{ $lang.ng_title }}</h2>
          <button class="ng-popup__close" @click="showChestPopup = false">
            <van-icon name="cross" size="20" color="rgba(255,255,255,0.7)" />
          </button>
        </div>

        <!-- Chest Image -->
        <div class="ng-popup__hero">
          <div class="ng-popup__hero-glow"></div>
          <img
            class="ng-popup__hero-img"
            src="../../../assets/img/refer_friend/img_isOpen_box.png"
          />
        </div>

        <!-- Countdown -->
        <div class="ng-popup__timer">
          <span class="ng-timer__label">{{ $lang.ng_limited_time }}</span>
          <div class="ng-timer__tube">
            <div class="ng-timer__pulse"></div>
            <span class="ng-timer__digits">{{ countdownDisplay }}</span>
          </div>
        </div>

        <!-- Total Reward Summary -->
        <div class="ng-popup__summary">
          <span class="ng-popup__summary-label">{{ $lang.ng_total_reward }}</span>
          <div class="ng-popup__summary-value">100% Bonus + 800 Coins</div>
        </div>

        <!-- Footer -->
        <div class="ng-popup__footer">
          <div class="ng-popup__total-value">
            <span>300% Total Value</span>
          </div>
          <button class="ng-popup__buy" :disabled="paying" @click="buyNow">
            {{ paying ? ($lang.common_loading || 'Loading...') : $lang.ng_buy_now }}
          </button>
          <p class="ng-popup__disclaimer">{{ $lang.ng_disclaimer }}</p>
        </div>
      </div>
    </van-popup>

    <!-- Payment iframe popup -->
    <van-popup
      v-model="payShow"
      closeable
      close-icon-position="top-right"
      style="width: 90%; border-radius: 10px; height: 80%"
    >
      <div>
        <iframe
          :src="payUrl"
          scrolling="no"
          style="width: 100%; height: 80vh"
          frameborder="0"
        ></iframe>
      </div>
    </van-popup>
    <login v-model="showLogin" overlay></login>

    <!-- Background Ambient -->
    <div class="ng-ambient">
      <div class="ng-ambient__green"></div>
      <div class="ng-ambient__yellow"></div>
    </div>
  </div>
</template>

<script>
import { NewPlayerGiftPackInit, ReceiveNewPlayerGiftPack, VnRechargeInitS, Pay } from '@/api/common'
import { reportPromoPanel } from '@/utils/common'
import { failMessage as rewardFailMessage, hasRewardIssueProof, hasUnavailableMarker, isClaimSuccess as rewardClaimSuccess, isNeedLogin, isOkResponse, responseContent } from './rewardApi'
import { activityPaymentUnavailableMessage, hasProvenEmptyActivityPaymentList, selectActivityPaymentMethod } from './activityPayment'

export default {
  name: 'NewbieGift',
  data() {
    return {
      purchased: false,
      showChestPopup: false,
      countdownTimer: null,
      price: '',
      originalPrice: '',
      promoType: '',
      giftList: [],
      rule: {},
      day1Status: 0, // 0=未开始 1=可领取 2=已领取
      day2Status: 0,
      day3Status: 0,
      day1AvailableTime: 0,
      day2AvailableTime: 0,
      day3AvailableTime: 0,
      nowTs: Math.floor(Date.now() / 1000),
      expireTime: 0,
      visible: 0,
      giftPackWritable: true,
      loading: false,
      paying: false,
      payShow: false,
      payUrl: '',
      showLogin: false
    }
  },
  computed: {
    toSec() {
      return (t) => {
        const n = Number(t) || 0
        return n > 1e12 ? Math.floor(n / 1000) : n
      }
    },
    countdownTarget() {
      // 未购买 → 到 expireTime；已购买 → 下一个未到的 dayNAvailableTime
      if (this.purchased) {
        const times = [
          this.toSec(this.day1AvailableTime),
          this.toSec(this.day2AvailableTime),
          this.toSec(this.day3AvailableTime)
        ].filter(t => t > this.nowTs).sort((a, b) => a - b)
        return times[0] || 0
      }
      return this.toSec(this.expireTime)
    },
    countdownSeconds() {
      if (!this.countdownTarget) return 0
      const diff = this.countdownTarget - this.nowTs
      return diff > 0 ? diff : 0
    },
    countdownDisplay() {
      const total = this.countdownSeconds
      if (!total) return '00:00:00'
      const d = Math.floor(total / 86400)
      const h = Math.floor((total % 86400) / 3600)
      const m = Math.floor((total % 3600) / 60)
      const s = total % 60
      if (d > 0) {
        return d + 'd ' + String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0')
      }
      return (
        String(h).padStart(2, '0') + ':' +
        String(m).padStart(2, '0') + ':' +
        String(s).padStart(2, '0')
      )
    },
    days() {
      const dayConfigs = [
        {
          dayIndex: 1,
          title: this.$lang.ng_day1_title,
          desc: this.$lang.ng_day1_desc,
          icon: require('../../../assets/img/bonus/coin.png'),
          apiStatus: this.day1Status,
          availableTime: this.toSec(this.day1AvailableTime)
        },
        {
          dayIndex: 2,
          title: this.$lang.ng_day2_title,
          desc: this.$lang.ng_day2_desc,
          icon: require('../../../assets/img/refer_friend/img_box_unopened.png'),
          apiStatus: this.day2Status,
          availableTime: this.toSec(this.day2AvailableTime)
        },
        {
          dayIndex: 3,
          title: this.$lang.ng_day3_title,
          desc: this.$lang.ng_day3_desc,
          icon: require('../../../assets/img/refer_friend/img_open_box.png'),
          apiStatus: this.day3Status,
          availableTime: this.toSec(this.day3AvailableTime)
        }
      ]
      return dayConfigs.map(cfg => {
        let status = 'locked'
        if (cfg.apiStatus === 2) {
          status = 'claimed'
        } else if (cfg.apiStatus === 1 && this.isGiftDayWritable(cfg.dayIndex)) {
          status = 'active'
        }
        let countdown = ''
        if (this.purchased && status === 'locked' && cfg.availableTime > this.nowTs) {
          const diff = cfg.availableTime - this.nowTs
          const d = Math.floor(diff / 86400)
          const h = Math.floor((diff % 86400) / 3600)
          const m = Math.floor((diff % 3600) / 60)
          if (d > 0) countdown = d + 'd ' + h + 'h'
          else if (h > 0) countdown = h + 'h ' + m + 'm'
          else countdown = m + 'm'
        }
        return { ...cfg, status, countdown }
      })
    }
  },
  mounted() {
    reportPromoPanel('new_player_giftpack', 1)
    this.initData()
    this.startCountdown()
  },
  beforeDestroy() {
    reportPromoPanel('new_player_giftpack', 2)
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer)
    }
  },
  methods: {
    requireLogin() {
      this.showLogin = true
      if (this.$bus) this.$bus.$emit('openLogin')
    },
    failMessage(res, fallback) {
      return rewardFailMessage(res, fallback || this.$lang.mc_claim_failed || 'This feature is temporarily unavailable. Please try again later.')
    },
    hasResponseContent(content) {
      return content &&
        typeof content === 'object' &&
        !Array.isArray(content) &&
        Object.keys(content).length > 0
    },
    firstPositiveTime(...values) {
      for (const value of values) {
        const n = Number(value)
        if (Number.isFinite(n) && n > 0) return value
      }
      return 0
    },
    safeArray(value) {
      return Array.isArray(value) ? value : []
    },
    positiveAmount(value) {
      const normalized = typeof value === 'string' ? value.replace(/,/g, '').trim() : value
      const n = Number(normalized)
      return Number.isFinite(n) && n > 0 ? n : 0
    },
    isNewbieGiftPurchasable() {
      return this.giftPackWritable !== false &&
        !!String(this.promoType || '').trim() &&
        Number(this.visible) > 0 &&
        this.positiveAmount(this.price) > 0
    },
    hasNewbieGiftReadData(content) {
      if (!this.hasResponseContent(content)) return false
      const keys = [
        'purchased',
        'day1Status',
        'day2Status',
        'day3Status',
        'day1AvailableTime',
        'day2AvailableTime',
        'day3AvailableTime',
        'expireTime',
        'endTime',
        'recvEndTime',
        'visible',
        'promoType',
        'price',
        'originalPrice',
        'giftList',
        'list',
        'items',
        'rule',
        'promoRule',
        'promoRules'
      ]
      return keys.some(key => Object.prototype.hasOwnProperty.call(content, key))
    },
    hasExistingGiftDisplay() {
      const rule = this.rule && typeof this.rule === 'object' ? this.rule : {}
      return !!(
        this.purchased ||
        Number(this.visible) > 0 ||
        String(this.promoType || '').trim() ||
        String(this.price || '').trim() ||
        String(this.originalPrice || '').trim() ||
        Number(this.day1Status) > 0 ||
        Number(this.day2Status) > 0 ||
        Number(this.day3Status) > 0 ||
        this.firstPositiveTime(this.day1AvailableTime, this.day2AvailableTime, this.day3AvailableTime, this.expireTime) ||
        this.safeArray(this.giftList).length ||
        this.safeArray(rule.giftList).length ||
        this.safeArray(rule.list).length ||
        this.safeArray(rule.items).length
      )
    },
    showReadFailure(res, fallback) {
      this.$toast({ message: this.failMessage(res, fallback || '活动请求失败，请稍后重试。'), icon: 'cross' })
    },
    failCloseGiftRead() {
      this.giftPackWritable = false
      this.payShow = false
      this.payUrl = ''
    },
    claimableGiftSources() {
      const rule = this.rule && typeof this.rule === 'object' ? this.rule : {}
      return [
        ...this.safeArray(this.giftList),
        ...this.safeArray(rule.giftList),
        ...this.safeArray(rule.list),
        ...this.safeArray(rule.items)
      ]
    },
    giftClaimItem(dayIndex) {
      const day = Number(dayIndex)
      return this.claimableGiftSources().find(item => Number(item && item.dayIndex) === day) || null
    },
    giftClaimPayload(dayIndex) {
      const item = dayIndex && typeof dayIndex === 'object' ? dayIndex : this.giftClaimItem(dayIndex)
      const day = Number((item && item.dayIndex) || dayIndex)
      if (!item || !Number.isFinite(day) || day <= 0) return null
      const payload = { dayIndex: day }
      for (const key of ['giftNo', 'recordNo', 'id']) {
        if (item[key] !== undefined && item[key] !== null && item[key] !== '') payload[key] = item[key]
      }
      return payload.giftNo || payload.recordNo || payload.id ? payload : null
    },
    isExplicitFailureValue(value) {
      if (value === false || value === 0) return true
      const normalized = String(value).trim().toLowerCase()
      return ['0', 'false', 'fail', 'failed', 'error', 'rejected'].includes(normalized)
    },
    hasWriteGuardMarker(source, depth = 0) {
      if (!source || typeof source !== 'object' || depth > 5) return false
      if (hasUnavailableMarker(source)) return true
      const blockingKeys = ['readOnly', 'readOnlyMode', 'readonly', 'read_only', 'read_only_mode', 'mock', 'mockMode', 'mock_mode', 'mockFallback', 'mock_fallback', 'stub', 'unimplemented', 'notImplemented', 'not_implemented', 'notSupported', 'not_supported', 'failed', 'failClosed', 'fail_closed', 'writeBlocked', 'write_blocked', 'backendBlocked', 'backend_blocked', 'backendFailure', 'backend_failure', 'paymentBackendBlocked', 'payment_backend_blocked', 'paymentStatusUnconfirmed', 'payment_status_unconfirmed', 'rewardBackendBlocked', 'reward_backend_blocked', 'fallback', 'fallbackUsed', 'fallback_used', 'dataUnavailable', 'data_unavailable', 'readFailure', 'read_failure', 'readUnavailable', 'read_unavailable', 'routeUnavailable', 'route_unavailable', 'technicalError', 'technical_error', 'technicalMarker', 'technical_marker', 'technicalException', 'technical_exception', 'notConnected', 'not_connected', 'falseProof', 'false_proof']
      const blockingTokens = ['mock', 'mock_mode', 'mock mode', 'mock-mode', 'mock_fallback', 'read_only', 'read_only_mode', 'read only mode', 'read-only-mode', 'readonly', 'readonlymode', 'read only', 'read-only', 'stub', 'unimplemented', 'not_implemented', 'not_supported', 'not supported', 'failed', 'failclosed', 'fail_closed', 'fail closed', 'fail-closed', 'write_blocked', 'writeblocked', 'write blocked', 'write-blocked', 'writeproof:false', 'write_proof:false', 'write proof:false', 'write-proof:false', 'writeproof false', 'write proof false', 'write-proof-false', 'backend_blocked', 'backendblocked', 'backend blocked', 'backend-blocked', 'backendfailure', 'backend_failure', 'backend failure', 'backend-failure', 'payment_backend_blocked', 'paymentbackendblocked', 'payment backend blocked', 'payment-backend-blocked', 'payment_status_unconfirmed', 'paymentstatusunconfirmed', 'payment status unconfirmed', 'payment-status-unconfirmed', 'reward_backend_blocked', 'rewardbackendblocked', 'reward backend blocked', 'reward-backend-blocked', 'fallback', 'fallback_used', 'fallback used', 'fallback-used', 'data_unavailable', 'data unavailable', 'data-unavailable', 'dataunavailable', 'readfailure', 'read_failure', 'read failure', 'read-failure', 'readunavailable', 'read_unavailable', 'read unavailable', 'read-unavailable', 'routeunavailable', 'route_unavailable', 'route unavailable', 'route-unavailable', 'falseproof', 'false_proof', 'false proof', 'false-proof', 'technical_error', 'technical error', 'technical-error', 'technicalmarker', 'technical_marker', 'technical marker', 'technical-marker', 'technicalexception', 'technical_exception', 'technical exception', 'technical-exception', '技术错误', '技术异常']
      const isActive = value => value === true || value === 1 || blockingTokens.some(token => String(value == null ? '' : value).trim().toLowerCase().includes(token))
      const isFalseProof = value => value === false || value === 0 || ['0', 'false', 'no', 'off'].includes(String(value == null ? '' : value).trim().toLowerCase()) || blockingTokens.some(token => String(value == null ? '' : value).trim().toLowerCase().includes(token))
      if (['writeProof', 'write_proof', 'rewardProof', 'reward_proof'].some(key => isFalseProof(source[key]))) return true
      if (blockingKeys.some(key => isActive(source[key]))) return true
      if ([source.status, source.state, source.result, source.code, source.errorCode, source.msg, source.message, source.errorMessage, source.errorMsg, source.reason, source.desc, source.description, source.detail, source.readOnlyMessage, source.unavailableReason].some(isActive)) return true
      return ['content', 'payload', 'extra', 'page', 'data', 'body', 'meta', 'trace', 'diagnostics', 'diagnostic', 'error', 'errors', 'detail', 'details'].some(key => this.hasWriteGuardMarker(source[key], depth + 1))
    },
    isGiftPackWritableSource(source) {
      if (!source || typeof source !== 'object') return false
      return !this.hasWriteGuardMarker(source) &&
        !this.isExplicitFailureValue(source.rewardWritable) &&
        !this.isExplicitFailureValue(source.claimWritable) &&
        !this.isExplicitFailureValue(source.purchaseWritable) &&
        !this.isExplicitFailureValue(source.writable) &&
        !this.isExplicitFailureValue(source.writeEnabled)
    },
    isGiftDayWritable(dayIndex) {
      const item = this.giftClaimItem(dayIndex)
      return this.giftPackWritable !== false &&
        !!this.giftClaimPayload(dayIndex) &&
        (!item || this.isGiftPackWritableSource(item))
    },
    paymentToken(value) {
      return String(value || '').trim().toLowerCase()
    },
    isUnavailablePaymentToken(value) {
      const token = this.paymentToken(value)
      return !!token && (
        ['stub', 'mock', 'mock_mode', 'mock mode', 'mock-mode', 'fallback', 'fallback_used', 'fallback used', 'fallback-used', 'dataunavailable', 'data_unavailable', 'data unavailable', 'data-unavailable', 'readfailure', 'read_failure', 'read failure', 'read-failure', 'readunavailable', 'read_unavailable', 'read unavailable', 'read-unavailable', 'routeunavailable', 'route_unavailable', 'route unavailable', 'route-unavailable', 'falseproof', 'false_proof', 'false proof', 'false-proof', 'technical_error', 'technical error', 'technical-error', 'technicalmarker', 'technical_marker', 'technical marker', 'technical-marker', 'technicalexception', 'technical_exception', 'technical exception', 'technical-exception', 'backendfailure', 'backend_failure', 'backend failure', 'backend-failure', '技术错误', '技术异常', 'read_only', 'read_only_mode', 'read only mode', 'read-only-mode', 'readonly', 'readonlymode', 'read only', 'read-only', 'unimplemented', 'not_implemented', 'not implemented', 'not_supported', 'not-supported', 'not supported', 'write_blocked', 'writeblocked', 'write blocked', 'write-blocked', 'writeproof:false', 'write_proof:false', 'write proof false', 'write-proof-false', 'backend_blocked', 'backendblocked', 'backend blocked', 'backend-blocked', 'unsupported', 'disabled', 'unavailable', 'need_login'].includes(token) ||
        token.includes('mock') ||
        token.includes('fallback') ||
        token.includes('backend_blocked') ||
        token.includes('backendblocked') ||
        token.includes('backend blocked') ||
        token.includes('backend-blocked') ||
        token.includes('data_unavailable') ||
        token.includes('data unavailable') ||
        token.includes('data-unavailable') ||
        token.includes('dataunavailable') ||
        token.includes('readfailure') ||
        token.includes('read_failure') ||
        token.includes('read failure') ||
        token.includes('read-failure') ||
        token.includes('readunavailable') ||
        token.includes('read_unavailable') ||
        token.includes('read unavailable') ||
        token.includes('read-unavailable') ||
        token.includes('routeunavailable') ||
        token.includes('route_unavailable') ||
        token.includes('route unavailable') ||
        token.includes('route-unavailable') ||
        token.includes('falseproof') ||
        token.includes('false_proof') ||
        token.includes('false proof') ||
        token.includes('false-proof') ||
        token.includes('technical_error') ||
        token.includes('technical error') ||
        token.includes('technical-error') ||
        token.includes('technicalmarker') ||
        token.includes('technical_marker') ||
        token.includes('technical marker') ||
        token.includes('technical-marker') ||
        token.includes('technicalexception') ||
        token.includes('technical_exception') ||
        token.includes('technical exception') ||
        token.includes('technical-exception') ||
        token.includes('backendfailure') ||
        token.includes('backend_failure') ||
        token.includes('backend failure') ||
        token.includes('backend-failure') ||
        token.includes('技术错误') ||
        token.includes('技术异常') ||
        token.includes('read_only') ||
        token.includes('readonlymode') ||
        token.includes('read only') ||
        token.includes('read-only') ||
        token.includes('unimplemented') ||
        token.includes('not_implemented') ||
        token.includes('not implemented') ||
        token.includes('not_supported') ||
        token.includes('not-supported') ||
        token.includes('not supported') ||
        token.includes('write_blocked') ||
        token.includes('writeblocked') ||
        token.includes('write blocked') ||
        token.includes('write-blocked') ||
        token.includes('writeproof:false') ||
        token.includes('write_proof:false') ||
        token.includes('write proof false') ||
        token.includes('write-proof-false') ||
        token.includes('need_login') ||
        token.includes('unsupported')
      )
    },
    isUsablePaymentMethod(payment) {
      const source = payment && typeof payment === 'object' ? payment : {}
      const key = this.paymentToken(source.paymentKey || source.paymentId)
      const status = this.paymentToken(source.status || source.paymentStatus || source.channelStatus)
      const closeValues = [source.isClose, source.closed, source.close].map(this.paymentToken)
      const enabledValues = [source.enabled, source.enable, source.isEnabled, source.open, source.isOpen]
      if (!key || hasUnavailableMarker(source) || this.isUnavailablePaymentToken(key) || this.isUnavailablePaymentToken(status)) return false
      if (['disabled', 'closed', 'off', 'offline', 'unavailable'].includes(status)) return false
      if (closeValues.some(value => ['1', 'true', 'yes'].includes(value))) return false
      return !enabledValues.some(value => value === false || ['0', 'false', 'no'].includes(this.paymentToken(value)))
    },
    rewardValue(content) {
      const c = content || {}
      return [
        c.amount,
        c.rewardAmount,
        c.awardAmount,
        c.reward,
        c.bonus,
        c.bonusAmount
      ].find(value => value !== undefined && value !== null && value !== '')
    },
    paymentUrl(content) {
      if (!content || typeof content !== 'object') return ''
      const url = content.url ||
        content.payUrl ||
        content.paymentUrl ||
        content.cashierUrl ||
        content.checkoutUrl ||
        content.redirectUrl ||
        content.qrcode ||
        content.qrCode ||
        ''
      return this.safePaymentUrl(url)
    },
    paymentOrderNo(content) {
      if (!content || typeof content !== 'object') return ''
      return [
        content.orderNo,
        content.orderId,
        content.recordNo,
        content.id,
        content.payOrderNo,
        content.paymentOrderNo,
        content.paymentNo,
        content.tradeNo
      ].find(value => this.isSafeBusinessProof(value)) || ''
    },
    isSafeBusinessProof(value) {
      const text = String(value || '').trim()
      if (!text) return false
      const token = this.paymentToken(text)
      return !this.isUnavailablePaymentToken(token) && ![
        '0',
        'none',
        'null',
        'undefined',
        'placeholder',
        'mock',
        'about:blank',
        '#',
        'javascript:void(0)'
      ].includes(token)
    },
    safePaymentUrl(value) {
      const text = String(value || '').trim()
      if (!this.isSafeBusinessProof(text) || text.charAt(0) === '#') return ''
      if (/^[a-z][a-z0-9+.-]*:/i.test(text) && !/^https?:\/\//i.test(text)) return ''
      return text
    },
    hasPaymentFailure(content) {
      if (!content || typeof content !== 'object') return false
      const status = String(content.status || content.state || '').trim().toLowerCase()
      return this.hasNonPositiveAffectedRows(content) || [
        content.paySuccess,
        content.success
      ].some(value => this.isExplicitFailureValue(value)) ||
        ['fail', 'failed', 'error', 'rejected'].includes(status)
    },
    hasNonPositiveAffectedRows(source, depth = 0) {
      if (!source || typeof source !== 'object' || depth > 5) return false
      const failed = [
        source.affectedRows,
        source.affected_rows
      ].some(value => {
        if (value === undefined || value === null || value === '') return false
        if (value === false || value === 0) return true
        if (value === true || value === 1) return false
        const number = Number(value)
        if (Number.isFinite(number)) return number <= 0
        const token = this.paymentToken(value)
        return ['false', 'no', 'off', 'fail', 'failed', 'none', 'null', 'undefined', 'placeholder'].includes(token) ||
          this.isUnavailablePaymentToken(value)
      })
      if (failed) return true
      const keys = ['content', 'payload', 'extra', 'page', 'data', 'body', 'meta', 'trace', 'diagnostics', 'diagnostic', 'error', 'errors', 'detail', 'details']
      return keys.some(key => this.hasNonPositiveAffectedRows(source[key], depth + 1))
    },
    paymentBodies(source, depth = 0, out = []) {
      if (!source || typeof source !== 'object' || depth > 5) return out
      if (this.hasResponseContent(source)) out.push(source)
      const keys = ['content', 'payload', 'extra', 'page', 'data', 'body', 'meta', 'trace', 'diagnostics', 'diagnostic', 'error', 'errors', 'detail', 'details']
      keys.forEach(key => {
        const value = source[key]
        if (Array.isArray(value)) {
          value.forEach(item => this.paymentBodies(item, depth + 1, out))
        } else if (value && typeof value === 'object') {
          this.paymentBodies(value, depth + 1, out)
        }
      })
      return out
    },
    paymentProofValues(body) {
      if (!body || typeof body !== 'object') return []
      return [
        body.payProof,
        body.pay_proof,
        body.orderProof,
        body.order_proof,
        body.paymentUrlProof,
        body.payment_url_proof,
        body.statusProof,
        body.status_proof,
        body.serverOrderStatusProof,
        body.server_order_status_proof
      ]
    },
    genericPaymentProofValues(body) {
      if (!body || typeof body !== 'object') return []
      return [
        body.paymentProof,
        body.payment_proof
      ]
    },
    isPositiveProofValue(value) {
      if (value === true || value === 1) return true
      const token = this.paymentToken(value)
      return ['1', 'true', 'yes', 'on'].includes(token) || this.isSafeBusinessProof(value)
    },
    hasPaymentSuccessProof(res) {
      const bodies = this.paymentBodies(res)
      if (bodies.some(body => this.hasNonPositiveAffectedRows(body))) return false
      const hasFalseProof = bodies.some(body => {
        return [
          ...this.paymentProofValues(body),
          ...this.genericPaymentProofValues(body)
        ].some(value => this.isExplicitFailureValue(value) || this.isUnavailablePaymentToken(value))
      })
      if (hasFalseProof) return false
      return bodies.some(body => {
        const proofs = this.paymentProofValues(body)
        if (proofs.some(value => this.isPositiveProofValue(value))) return true
        return false
      })
    },
    newbieRewardProofValues(body) {
      if (!body || typeof body !== 'object') return []
      return [
        body.rewardProof,
        body.reward_proof,
        body.rewardIssueProof,
        body.reward_issue_proof,
        body.serverRewardProof,
        body.server_reward_proof,
        body.rewardIssued,
        body.reward_issued
      ]
    },
    hasExplicitNewbieRewardProof(res) {
      const bodies = this.paymentBodies(res)
      if (bodies.some(body => this.hasNonPositiveAffectedRows(body))) return false
      const proofValues = bodies.flatMap(body => this.newbieRewardProofValues(body))
      if (proofValues.some(value => this.isExplicitFailureValue(value) || this.isUnavailablePaymentToken(value))) return false
      return proofValues.some(value => this.isPositiveProofValue(value))
    },
    isClaimSuccess(res) {
      return !this.hasWriteGuardMarker(res) &&
        rewardClaimSuccess(res) &&
        hasRewardIssueProof(res) &&
        this.hasExplicitNewbieRewardProof(res)
    },
    isPaymentReady(res) {
      const content = responseContent(res)
      if (this.hasWriteGuardMarker(res) || this.hasNonPositiveAffectedRows(res) || !isOkResponse(res) || !this.hasResponseContent(content)) return false
      return !this.hasPaymentFailure(content) && !!this.paymentUrl(content) && this.hasPaymentSuccessProof(res)
    },
    async initData() {
      try {
        const res = await NewPlayerGiftPackInit({})
        if (isNeedLogin(res)) {
          this.failCloseGiftRead()
          this.requireLogin()
        } else if (isOkResponse(res)) {
          const d = responseContent(res)
          if (this.hasWriteGuardMarker(res) || this.hasWriteGuardMarker(d) || !this.hasNewbieGiftReadData(d)) {
            this.failCloseGiftRead()
            const fallback = this.hasExistingGiftDisplay()
              ? '活动请求失败，请稍后重试，已保留已加载礼包数据。'
              : '活动请求失败，请稍后重试。'
            this.showReadFailure(res, fallback)
            return
          }
          this.giftPackWritable = this.isGiftPackWritableSource(d)
          this.purchased = Number(d.purchased) === 1
          this.day1Status = Number(d.day1Status) || 0
          this.day2Status = Number(d.day2Status) || 0
          this.day3Status = Number(d.day3Status) || 0
          this.day1AvailableTime = d.day1AvailableTime || 0
          this.day2AvailableTime = d.day2AvailableTime || 0
          this.day3AvailableTime = d.day3AvailableTime || 0
          this.expireTime = this.firstPositiveTime(d.expireTime, d.endTime, d.recvEndTime, d.day3AvailableTime, d.day2AvailableTime, d.day1AvailableTime)
          this.visible = Number(d.visible) || 0
          this.promoType = d.promoType || ''
          this.giftList = this.safeArray(d.giftList || d.list || d.items)
          this.rule = d.rule || d.promoRule || d.promoRules || {}
          if (d.price) {
            this.price = d.price
          }
          if (d.originalPrice) {
            this.originalPrice = d.originalPrice
          }
        } else {
          this.failCloseGiftRead()
          this.$toast({ message: this.failMessage(res, 'This feature is temporarily unavailable. Please try again later.'), icon: 'cross' })
        }
      } catch (e) {
        this.failCloseGiftRead()
        this.$toast({ message: this.failMessage(e, '活动请求失败，请稍后重试。'), icon: 'cross' })
      }
    },
    startCountdown() {
      this.nowTs = Math.floor(Date.now() / 1000)
      this.countdownTimer = setInterval(() => {
        this.nowTs = Math.floor(Date.now() / 1000)
      }, 1000)
    },
    async claimReward(dayIndex) {
      if (this.loading) return
      if (!this.token) {
        this.requireLogin()
        return
      }
      if (this.giftPackWritable === false) {
        this.$toast({ message: this.failMessage(null, 'This feature is temporarily unavailable. Please try again later.'), icon: 'cross' })
        return
      }
      const claimPayload = this.giftClaimPayload(dayIndex)
      if (!claimPayload) {
        this.$toast({ message: this.failMessage(null, 'This feature is temporarily unavailable. Please try again later.'), icon: 'cross' })
        return
      }
      this.loading = true
      try {
        const res = await ReceiveNewPlayerGiftPack(claimPayload)
        if (isNeedLogin(res)) {
          this.requireLogin()
        } else if (this.isClaimSuccess(res)) {
          const claimContent = responseContent(res)
          // Update the day status to claimed
          const day = Number(claimPayload.dayIndex)
          if (day === 1) this.day1Status = 2
          else if (day === 2) this.day2Status = 2
          else if (day === 3) this.day3Status = 2
          const amount = this.rewardValue(claimContent)
          const message = amount !== undefined && amount !== null && amount !== ''
            ? `+${this.getCurrency}${this.$formatNumberWithCommas(amount)}`
            : (this.$lang.bonus_txt16 || 'Success')
          this.$toast({
            message,
            icon: 'success'
          })
          // Refresh data to get updated statuses
          this.initData()
        } else {
          this.$toast({ message: this.failMessage(res, 'This feature is temporarily unavailable. Please try again later.'), icon: 'cross' })
        }
      } catch (e) {
        const networkFallback = this.$lang.network_error === 'Network error'
          ? '活动网络请求失败，请稍后重试。'
          : (this.$lang.network_error || '活动网络请求失败，请稍后重试。')
        this.$toast({ message: this.failMessage(e, networkFallback), icon: 'cross' })
      } finally {
        this.loading = false
      }
    },
    async buyNow() {
      if (this.paying) return
      if (!this.token) {
        this.requireLogin()
        return
      }
      if (!this.isNewbieGiftPurchasable()) {
        this.$toast({ message: this.failMessage(null, 'This feature is temporarily unavailable. Please try again later.'), icon: 'cross' })
        return
      }
      this.paying = true
      this.showChestPopup = false
      try {
        const initRes = await VnRechargeInitS()
        if (isNeedLogin(initRes)) {
          this.requireLogin()
          return
        }
        const initContent = responseContent(initRes)
        const hasProvenEmptyPayments = typeof hasProvenEmptyActivityPaymentList === 'function' &&
          (hasProvenEmptyActivityPaymentList(initRes) || hasProvenEmptyActivityPaymentList(initContent))
        const selectedPayment = selectActivityPaymentMethod(initContent.paymentList || initContent)
        if ((!isOkResponse(initRes) && !hasProvenEmptyPayments) || !this.hasResponseContent(initContent) || !selectedPayment) {
          const message = hasProvenEmptyPayments && !selectedPayment
            ? activityPaymentUnavailableMessage()
            : this.failMessage(initRes, activityPaymentUnavailableMessage())
          this.$toast({ message, icon: 'cross' })
          return
        }
        const payRes = await Pay({
          paymentAmount: this.price,
          paymentId: selectedPayment.paymentId,
          paymentKey: selectedPayment.paymentKey,
          paymentType: selectedPayment.paymentType,
          rechargeFees: selectedPayment.rechargeFees,
          phone: initContent._account,
          promoType: this.promoType || 'new_player_giftpack'
        })
        const payContent = responseContent(payRes)
        if (isNeedLogin(payRes)) {
          this.requireLogin()
        } else {
          const payUrl = this.paymentUrl(payContent)
          if (!this.isPaymentReady(payRes) || !payUrl) {
            this.$toast({ message: this.failMessage(payRes, 'This feature is temporarily unavailable. Please try again later.'), icon: 'cross' })
            return
          }
          this.payUrl = payUrl
          this.payShow = true
        }
      } catch (e) {
        this.$toast({ message: this.failMessage(e, '活动请求失败，请稍后重试。'), icon: 'cross' })
      } finally {
        this.paying = false
      }
    },
    openChestPopup() {
      this.showChestPopup = true
    }
  }
}
</script>

<style lang="less" scoped>
@primary: @brand;        /* 绿→火焰橙(强调/激活/CTA) */
@secondary: #ffb020;     /* 黄→金(金额/奖) */
@bg-dark: @vk-bg;        /* 页面底 */
@navy-800: @vk-surface;  /* 去蓝调,中性卡片面 */
@navy-700: @vk-surface-2;/* 去蓝调,二级面 */
@red: #f5455c;           /* 红保留语义(--vk-danger) */

.newbie-gift {
  min-height: 100vh;
  background: @bg-dark;
  color: #f1f5f9;
  position: relative;
  overflow: hidden;
}

// ====== HEADER ======
.ng-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  max-width: var(--vk-pc-col);
  margin: 0 auto;
  z-index: 50;
  background: @bg-dark;
  backdrop-filter: blur(12px);

  &__back {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background: none;
    border: none;
    cursor: pointer;
  }

  &__title {
    font-size: var(--vk-fs-lg);
    font-weight: 800;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: #ffffff;
    text-shadow: 0 0 15px rgba(248, 245, 16, 0.6);
  }

  &__spacer {
    width: 40px;
  }
}

// ====== MAIN ======
.ng-main {
  max-width: var(--vk-pc-col);
  margin: 0 auto;
  padding-top: 72px;
  padding-bottom: 200px;
}

// ====== HERO ======
.ng-hero {
  padding: 8px 16px 32px;

  &__img-wrap {
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    position: relative;
    margin-bottom: 24px;
  }

  &__img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
  }

  &__badge {
    position: absolute;
    top: 16px;
    right: 16px;
    background: @secondary;
    color: @bg-dark;
    font-weight: 900;
    font-size: var(--vk-fs-xs);
    padding: 4px 12px;
    border-radius: 9999px;
    animation: pulse-badge 2s ease-in-out infinite;
  }
}

@keyframes pulse-badge {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

// ====== TIMER ======
.ng-timer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  &__label {
    font-size: var(--vk-fs-xs);
    color: rgba(255, 255, 255, 0.7);
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 3px;
  }

  &__tube {
    width: 100%;
    max-width: 280px;
    padding: 12px;
    border-radius: 16px;
    border: 2px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    position: relative;
    overflow: hidden;

    &--green {
      .ng-timer__pulse {
        background: fade(@primary, 5%);
      }
    }
  }

  &__pulse {
    position: absolute;
    inset: 0;
    background: fade(@red, 5%);
    animation: timer-pulse 2s ease-in-out infinite;
  }

  &__digits {
    font-size: 36px;
    font-weight: 900;
    letter-spacing: 3px;
    color: @red;
    z-index: 10;
    text-shadow: 0 0 10px fade(@red, 50%);
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.5));

    &--green {
      color: @primary;
      text-shadow: 0 0 10px fade(@primary, 50%);
    }
  }
}

@keyframes timer-pulse {
  0%, 100% { opacity: 0.5; }
  50% { opacity: 1; }
}

// ====== REWARD CARDS ======
.ng-rewards {
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.ng-reward-card {
  background: fade(@navy-800, 50%);
  box-shadow:
    inset 0 1px 1px rgba(255, 255, 255, 0.1),
    0 4px 6px -1px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.05);
  padding: 16px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 16px;
  opacity: 0.7;
  filter: grayscale(0.5);

  &--active,
  &--claimed {
    background: @navy-800;
    border-left: 4px solid @primary;
    box-shadow:
      inset 0 1px 1px rgba(255, 255, 255, 0.1),
      0 4px 6px -1px rgba(0, 0, 0, 0.5),
      0 10px 20px fade(@primary, 5%);
    opacity: 1;
    filter: none;
  }

  &__icon {
    width: 64px;
    height: 64px;
    background: @navy-700;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border: 1px solid rgba(255, 255, 255, 0.05);

    &--active {
      background: fade(@primary, 20%);
      border-color: fade(@primary, 30%);
    }

    &-img {
      width: 48px;
      height: 48px;
      object-fit: contain;
    }
  }

  &__info {
    flex: 1;
    min-width: 0;
  }

  &__head {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__title {
    font-size: var(--vk-fs-base);
    font-weight: 700;
    color: #ffffff;
  }

  &__desc {
    font-size: var(--vk-fs-xs);
    color: var(--vk-t2);
    margin-top: 4px;
    line-height: 1.4;

    /deep/ .highlight {
      color: @primary;
      font-weight: 700;
    }
  }

  &__btn {
    flex-shrink: 0;
    font-size: var(--vk-fs-xs);
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: -0.3px;
    padding: 8px 16px;
    border-radius: 10px;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;

    &--active {
      background: @primary;
      color: @bg-dark;
      box-shadow: 0 0 10px fade(@primary, 40%);

      &:active {
        transform: scale(0.95);
      }
    }

    &--disabled {
      background: fade(#475569, 50%);
      color: var(--vk-t2);
      cursor: not-allowed;
      border: 1px solid rgba(255, 255, 255, 0.05);
      box-shadow: none;
    }

    &--locked {
      background: fade(#475569, 50%);
      color: var(--vk-t3);
      cursor: not-allowed;
      border: 1px solid rgba(255, 255, 255, 0.05);
    }
  }
}

.ng-badge {
  font-size: var(--vk-fs-2xs);
  font-weight: 900;
  text-transform: uppercase;
  padding: 2px 8px;
  border-radius: 4px;

  &--active {
    color: @primary;
    background: fade(@primary, 10%);
  }

  &--claimed {
    color: var(--vk-t2);
    background: @vk-surface-2;
  }
}

.ng-spacer {
  height: 40px;
}

// ====== FOOTER ======
.ng-footer {
  position: fixed;
  bottom: 30px;
  left: 0;
  right: 0;
  background: fade(@bg-dark, 95%);
  backdrop-filter: blur(20px);
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  padding: 16px;
  max-width: var(--vk-pc-col);
  margin: 0 auto;
  z-index: 50;

  &__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  &__price {
    display: flex;
    flex-direction: column;

    &-label {
      font-size: var(--vk-fs-2xs);
      color: var(--vk-t2);
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 2px;
    }

    &-row {
      display: flex;
      align-items: baseline;
      gap: 6px;
    }

    &-current {
      font-size: 30px;
      font-weight: 900;
      color: @secondary;
      text-shadow: 0 0 15px fade(@secondary, 60%);
    }

    &-original {
      font-size: var(--vk-fs-base);
      color: var(--vk-t3);
      text-decoration: line-through;
    }
  }

  &__value {
    text-align: right;

    &-pct {
      font-size: var(--vk-fs-xl);
      font-weight: 900;
      color: @primary;
    }

    &-label {
      font-size: var(--vk-fs-2xs);
      color: var(--vk-t2);
      font-weight: 700;
    }
  }

  &__buy {
    width: 100%;
    background: @primary;
    color: @bg-dark;
    font-weight: 900;
    padding: 16px;
    border-radius: 10px;
    border: none;
    font-size: var(--vk-fs-md);
    text-transform: uppercase;
    letter-spacing: 3px;
    box-shadow: 0 0 20px fade(@primary, 40%);
    cursor: pointer;

    &:active {
      transform: scale(0.98);
    }
  }

  &__disclaimer {
    text-align: center;
    font-size: var(--vk-fs-2xs);
    color: var(--vk-t3);
    margin-top: 12px;
    font-weight: 500;
  }
}

// ====== POPUP ======
.ng-popup-wrapper {
  background: transparent !important;
  overflow: visible !important;
}

.ng-popup {
  width: 100%;
  max-width: 420px;
  background: @bg-dark;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  display: flex;
  flex-direction: column;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  }

  &__title {
    font-size: var(--vk-fs-lg);
    font-weight: 800;
    color: @primary;
    text-transform: uppercase;
    letter-spacing: 2px;
    text-shadow: 0 0 10px fade(@primary, 50%);
  }

  &__close {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    cursor: pointer;
  }

  &__hero {
    width: 100%;
    aspect-ratio: 4 / 3;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background: linear-gradient(to bottom, fade(@primary, 10%), transparent);

    &-glow {
      position: absolute;
      inset: 0;
      opacity: 0.2;
      background: radial-gradient(circle at center, @primary, transparent, transparent);
    }

    &-img {
      width: 256px;
      height: 256px;
      object-fit: contain;
      position: relative;
      z-index: 10;
    }
  }

  &__timer {
    padding: 0 24px;
    margin-top: -32px;
    position: relative;
    z-index: 20;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  &__summary {
    margin: 20px 24px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    padding: 16px;
    text-align: center;

    &-label {
      font-size: var(--vk-fs-2xs);
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 2px;
      color: @red;
      display: block;
      margin-bottom: 4px;
    }

    &-value {
      font-size: var(--vk-fs-xl);
      font-weight: 900;
      color: @secondary;
    }
  }

  &__footer {
    padding: 24px;
    padding-top: 8px;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.4), transparent);
    margin-top: auto;
  }

  &__total-value {
    text-align: center;
    margin-bottom: 16px;

    span {
      font-size: var(--vk-fs-lg);
      font-weight: 900;
      color: @primary;
      text-transform: uppercase;
      letter-spacing: 3px;
      text-shadow: 0 0 10px fade(@primary, 50%);
    }
  }

  &__buy {
    width: 100%;
    background: @primary;
    color: @bg-dark;
    font-weight: 900;
    padding: 20px;
    border-radius: 12px;
    border: none;
    font-size: var(--vk-fs-lg);
    text-transform: uppercase;
    letter-spacing: 4px;
    box-shadow: 0 10px 30px fade(@primary, 40%);
    cursor: pointer;

    &:active {
      transform: scale(0.95);
    }
  }

  &__disclaimer {
    text-align: center;
    font-size: var(--vk-fs-2xs);
    color: rgba(255, 255, 255, 0.3);
    margin-top: 12px;
    font-weight: 500;
  }
}

// ====== AMBIENT ======
.ng-ambient {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: -1;
  overflow: hidden;

  &__green {
    position: absolute;
    top: -10%;
    right: -10%;
    width: 256px;
    height: 256px;
    background: fade(@primary, 10%);
    filter: blur(100px);
    border-radius: 50%;
  }

  &__yellow {
    position: absolute;
    bottom: 20%;
    left: -10%;
    width: 320px;
    height: 320px;
    background: fade(@secondary, 5%);
    filter: blur(120px);
    border-radius: 50%;
  }
}

// ====== RESPONSIVE ======
@media (min-width: 769px) {
  .ng-main {
    max-width: var(--vk-pc-col);
    margin: 0 auto;
  }
}
</style>
